import React, { useEffect, useRef, useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Dropdown } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddOutlinedIcon from "@material-ui/icons/GroupAddOutlined";
// import InsertInvitationOutlinedIcon from "@material-ui/icons/InsertInvitationOutlined";
import { Card } from "react-bootstrap";
import MuiAlert from "@material-ui/lab/Alert";
import { AssignCoach } from './AssignCoach'
import SeeCoach from './SeeCoach'
import { SeeClients } from './SeeClients'
import { shallowEqual, useSelector } from "react-redux";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';


import {
  TablePagination,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Box,
  makeStyles,
  Typography,
  ButtonGroup,
  InputBase,
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  TextField
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete'
import { FetchUsersList, AssignNewCoach, FetchCoacheList, FetchOrganizationList, AddUser, CreateCheckoutSession, BlockunblockUser, UpdateType, AddBulkUser } from "../apis";
import { ClientProfile } from "./ClientProfile";
import { FetchOrganizationUsersList } from "../../../apis";

import Tooltip from '@material-ui/core/Tooltip';

import { useParams } from 'react-router-dom'
import { default as RSelect } from 'react-select';

import * as XLSX from 'xlsx';
import { JobseekerPurchaseHistory } from "./JobseekerPurchaseHistory";

import Swal from 'sweetalert2'
import { icon } from "@fortawesome/fontawesome-svg-core";

// users list
const GET_USERS_LIST = gql`
  query Query(
    $getAllUsersListPageNo: Int
    $getAllUsersListLimit: Int
    $getAllUsersListSearchText: String
  ) {
    getAllUsersList(
      pageNo: $getAllUsersListPageNo
      limit: $getAllUsersListLimit
      searchText: $getAllUsersListSearchText
    ) {
      usersList {
        id
        firstName
        lastName
        email
        isBlocked
        type
        invitedBy
      }
      usersCount
      pageNo
    }
  }
`;

// add client
const ADD_CLIENT = gql`
  mutation Mutation(
    $sendCoachInvitationEmail: String!
    $sendCoachInvitationFirstName: String!
    $sendCoachInvitationLastName: String!
    $sendCoachInvitationType: String!
  ) {
    sendCoachInvitation(
      email: $sendCoachInvitationEmail
      firstName: $sendCoachInvitationFirstName
      lastName: $sendCoachInvitationLastName
      type: $sendCoachInvitationType
    ) {
      code
      success
      message
    }
  }
`;
// block mutation
const BLOCK_USER = gql`
  mutation Mutation($blockUserUserId: String) {
    blockUser(userId: $blockUserUserId) {
      code
      success
      message
    }
  }
`;

const UNBLOCK_USER = gql`
  mutation Mutation($unblockUserUserId: String) {
    unblockUser(userId: $unblockUserUserId) {
      code
      success
      message
    }
  }
`;
// unblock mutation

// css
const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
  },
  table: {
    minWidth: 1050,
  },
  tableHeadCell: {
    fontSize: "18px",
  },
  tableRowCell: {
    fontSize: "14px",
    borderBottom: "none",
    lineHeight: "40px",
    align: "left",
  },
  dropdown: {
    position: "absolute",
    top: 28,
    right: 0,
    left: 0,
    zIndex: 1,
    border: "1px solid",
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "#f2f2f2",
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "14px",
  },
  inputInput: {
    padding: theme.spacing(1.5, 1.5, 1.5, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));
// end of css

let headers = ["Client Name", "Email", "Department", "Phone", "Payment", "Status", "Type", "Client/Coach", "Action"];
// let headers = ["Client Name", "Email", "Phone", "Stage", "Payment", "Status", "Type", "Client/Coach", "Action"];

// let rows = [];
let count;
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export function ClientListTable() {

  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearchText] = React.useState("");
  const [DialogState, setDialogState] = React.useState(false);
  const [userId, setUserIdForBlock] = React.useState("");
  const [blockedUser, setUserNameForBlock] = React.useState("");
  const [rows, setRows] = useState([])
  const [coaches, setCoaches] = useState([])
  const [oragnizations, setOrganizations] = useState([])
  const [filter, setFilter] = React.useState('All')
  const [sort, setSort] = React.useState(1)
  // const [count, setCount] = useState()

  const { data, refetch } = useQuery(GET_USERS_LIST, {
    variables: {
      getAllUsersListPageNo: page,
      getAllUsersListLimit: rowsPerPage,
      getAllUsersListSearchText: search,
    },
  });

  const [snackBarText, setSnackBarText] = React.useState("");
  const [snackBarOpen, setSnackBarOpen] = React.useState(false);
  const [snackBarVariant, setSnackBarVariant] = React.useState("success");

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [userType, setUserType] = React.useState('COACH')
  const [addClientLoader, setAddClientLoader] = React.useState(false);
  const [assigningCoach, setAssigningCoach] = React.useState(false);
  const [assignCoach, setAssignCoach] = React.useState(false);
  const [seeCoach, setSeeCoach] = React.useState(false);
  const [seeJobSeeker, setSeeJobSeeker] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState('')
  const [selectedJs, setSelectedJs] = React.useState()
  const [seeUserModal, setSeeUserModal] = React.useState(false);

  const [coachSearch, setCoachSearch] = React.useState('')
  const [selectedCoach, setSelectedCoach] = React.useState()

  const [organizationSearch, setOrganizationSearch] = React.useState('')
  const [selectedOrganization, setSelectedOrganization] = React.useState()

  const [paymentUserId, setPaymentUserId] = useState(null);

  const params = useParams();

  React.useEffect(()=>{
    handleRestFile();
  }, [userType])

  const [addClient] = useMutation(ADD_CLIENT, {
    onCompleted(addClient) {
      setSnackBarVariant("success");
      setSnackBarText("Invitation sent successfully");
      setSnackBarOpen(true);
      setAddClientLoader(false);
      setDialogState(false);
      fetchUsers(page, rowsPerPage, search, sort, filter)
    },
  });
  const [blockUser] = useMutation(BLOCK_USER, {
    variables: {
      blockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("error");
      setSnackBarText("you have blocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const [unBlockUser] = useMutation(UNBLOCK_USER, {
    variables: {
      unblockUserUserId: userId,
    },
    onCompleted() {
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setUserIdForBlock("");
      setSnackBarVariant("success");
      setSnackBarText("you have unblocked " + blockedUser);
      setSnackBarOpen(true);
    },
  });

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const searchText = (event) => {
    setSearchText(event.target.value);

    if (event.target.value.length > 2) {
      fetchUsers(page, rowsPerPage, event.target.value, sort, filter);
    } else if (event.target.value.length === 0) fetchUsers(page, rowsPerPage, search, sort, filter);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchUsers(newPage, rowsPerPage, search, sort, filter);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    // fetchUsers();
  };

  const handleDialogOpen = () => {
    setDialogState(true);
  };

  const handleDialogClose = () => {
    setDialogState(false);
    setDepartment("");
    handleRestFile();
  };
  const classes = useStyles();

  const handleBlock = async (id, name) => {
    setUserIdForBlock(id);
    setUserNameForBlock(name);
    // blockUser({
    //   variables: { blockUserUserId: id },
    // });
    try{
      let res = await BlockunblockUser(id);
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setSnackBarVariant("error");
      setSnackBarText("you have blocked " + name);
      setSnackBarOpen(true);
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackBarVariant("error");
      setSnackBarText(error);
      setSnackBarOpen(true);
    }finally{
      setUserNameForBlock(null);
      setUserIdForBlock(null);
    }
      
  };
  const handleUnBlock = async (id, name) => {
    setUserNameForBlock(name);
    setUserIdForBlock(id);
    try{
      let res = await BlockunblockUser(id);
      fetchUsers(page, rowsPerPage, search, sort, filter);
      setSnackBarVariant("success");
      setSnackBarText("you have unblocked " + name);
      setSnackBarOpen(true);
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackBarVariant("error");
      setSnackBarText(error);
      setSnackBarOpen(true);
    }finally{
      setUserNameForBlock(null);
      setUserIdForBlock(null);
    }
    // unBlockUser({
    //   variables: { unblockUserUserId: id },
    // });
  };
  const handleFirstName = (evt) => {
    setFirstName(evt.target.value);
  };
  const handleLastName = (evt) => {
    setLastName(evt.target.value);
  };
  const handleEmail = (evt) => {
    setEmail(evt.target.value);
  };

  const hanldeUserType = (evt) => {
    setUserType(evt.target.value)
  }
  const handleAddClient = async () => {

    if (!userType) {
      setSnackBarVariant("error");
      setSnackBarText("User Type is Required");
    }
    setAddClientLoader(true);

    let data = {
      email,
      firstName,
      lastName,
      type: userType,
      ...(selectedCoach && selectedCoach._id ? { invitedBy: selectedCoach._id } : {}),
      ...(userType === 'COACH' && department ? { department } : {}),
      organization: user.organization
    }

    let addUser = await AddUser(data)
    if (addUser.data.success) {
      setSnackBarOpen(true);
      setSnackBarVariant("success");
      setSnackBarText("User created successfully and login details sents via email.");
    } else {
      setSnackBarOpen(true);
      setSnackBarVariant("error");
      setSnackBarText(addUser.data.message);
    }
    // setSnackBarVariant("success");
    // setSnackBarText("Invitation sent successfully");
    setAddClientLoader(false);
    handleDialogClose()
    fetchUsers(page, rowsPerPage, search, sort, filter)
    // addClient({
    //   variables: {
    //     sendCoachInvitationEmail: email,
    //     sendCoachInvitationFirstName: firstName,
    //     sendCoachInvitationLastName: lastName,
    //     sendCoachInvitationType: userType
    //   },
    // });
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackBarOpen(false);
  };

  // if (typeof data === "object") {
  //   count = parseInt(data.getAllUsersList.usersCount);
  //   rows = data.getAllUsersList.usersList.map((key) => {
  //     var blockStatus;
  //     if (key.isBlocked) {
  //       blockStatus = "Blocked";
  //     } else {
  //       blockStatus = "Active";
  //     }
  //     console.log("key:-=-=", key)
  //     return {
  //       id: key.id,
  //       name: key.firstName + " " + key.lastName,
  //       email: key.email,
  //       phone: "N/A",
  //       stage: "Needs Resume Review",
  //       status: blockStatus,
  //       action: key.isBlocked,
  //       type: key.type === "JOB_SEEKER" ? 'Job Seeker' : "Coach"
  //     };
  //   });
  // }

  const refresh = () =>{
    fetchUsers(page, rowsPerPage, search, sort, filter)
    FetchCoaches()
  }

  React.useEffect(() => {
    fetchUsers(page, rowsPerPage, search, sort, filter)
    FetchCoaches()
    // FetchOrganizations()
  }, {})

  const FetchCoaches = async (s = '') => {
    let result = await FetchCoacheList(s ? s : '', user.organization)
    // let users = result.data.users.filter(ele => !ele.isAdminOrg )
    setCoaches([...result.data.users])
  }

  const FetchOrganizations = async (s = '') => {
    let result = await FetchOrganizationList(s ? s : '')
    setOrganizations([...result.data.organizations])
  }

  const fetchUsers = async (p, r, s, st, f) => {
    if (!user.organization) return
    let result = await FetchOrganizationUsersList(user.organization, p, r, s, st, f === "All" ? '' : f)
    console.log("result: ", result.data)
    let newRows = result.data.users.map((key) => {
      var blockStatus;
      if (key.isBlocked) {
        blockStatus = "Blocked";
      } else {
        blockStatus = "Active";
      }
      console.log("key:-=-=", key)
      let paymentMessage = "Paid"
      if(key.pendingAmount){
        paymentMessage = `Payment Pending ($${key.pendingAmount})`
      }else{
        if(!key.package){
          paymentMessage = `Payment Pending ($45)`
        }
      }

      if(key.type == "JOB_SEEKER"){
        paymentMessage = "N/A"
      }
      return {
        id: key._id,
        name: key.firstName + " " + key.lastName,
        email: key.email,
        department: key.department || '',
        phone: "N/A",
        stage: "Needs Resume Review",
        status: blockStatus,
        action: key.isBlocked,
        type: key.type === "JOB_SEEKER" ? 'Job Seeker' : key.type === "ADMIN" ? 'Admin' : "Coach",
        invitedBy: key.invitedBy,
        paymentMessage,
        pendingAmount: key.pendingAmount || 45
      };
    })

    setRows([...newRows])
    count = result.data.count
  }

  const onSelectCategory = (evt) => {
    setFilter(evt.target.value)
    fetchUsers(page, rowsPerPage, search, sort, evt.target.value)
  }

  const openAssignCoach = (data) => {
    setAssignCoach(true)
    setSelectedJs(data)
  }

  const closeAssignCoach = () => {
    setAssignCoach(false)
    setSelectedJs(undefined)

  }


  const onAssigngingCoach = async (data) => {
    setAssigningCoach(true)
    let update = await AssignNewCoach(data)
    closeAssignCoach()
    setAssigningCoach(false)
    fetchUsers(page, rowsPerPage, search, sort, filter)
  }

  const openSeeClientPopup = (id) => {
    setSeeJobSeeker(true)
    setSelectedUser(id)
  }

  const closeSeeClientPopup = () => {
    setSeeJobSeeker(false)
    setSelectedUser('')
  }

  const openSeeCoach = (id) => {
    setSeeCoach(true)
    setSelectedUser(id)
  }

  const closeSeeCoach = (id) => {
    setSeeCoach(false)
    setSelectedUser('')
  }

  const openUserDetails = (data) => {
    console.log("Dayta", data)
    setSeeUserModal(true)
    setSelectedJs(data)
  }

  const closeUserDetails = (data) => {
    setSeeUserModal(false)
    setSelectedJs(undefined)
  }

  const onChangesCoachesSearch = (evt) => {
    setCoachSearch(evt)
    FetchCoaches(evt)
  }
  const onChangesOrganizationsSearch = (evt) => {
    setOrganizationSearch(evt)
    FetchOrganizations(evt)
  }

  const handleCreateCheckoutSession = async (id, row) => {
    try{
      console.log(row, 'row');
      setPaymentUserId(id)
      let data = await CreateCheckoutSession(row);
      window.location.href = data.url
      // console.log(data);
    }catch(ex){
      console.log(ex);
      let error = ex.response ? ex.response.data.message : ex.message;
      console.log(error);
    }
  }
  const [changeTypeUserId, setChangeTypeUserId] = useState(null);

  const handleChangeType = async (id, type) => {
    setChangeTypeUserId(id)
    let res = await UpdateType(id, type)
    fetchUsers(page, rowsPerPage, search, sort, filter);
    setChangeTypeUserId(null)
      setSnackBarVariant("success");
      setSnackBarText(res.message);
      setSnackBarOpen(true);
  }

  // Jobseeker upload
  const [file, setFile] = useState(null);
  const inpRef = useRef(null);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const [openMapPopup, setOpenMapPopup] = useState(false);
  const [isSheetSelected, setIsSheetSelected] = useState(false);
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [sheetList, setSheetList] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [mapping, setMapping] = useState({});
  
  const [processing, setProcessing] = useState(false);

  const [openFinalStep, setOpenFinalStep] = useState(false);  
  const [validating, setValidating] = useState(false);
  const [errors, setErrors] = useState([]);

  const [importing, setImporting] = useState(false);

  const [result, setResult] = useState(null);

  const all_fields = [
    "firstName",
    "lastName",
    "email",
    "birthDate",
    "cellPhone",
    "gender",
    "address",
    "source",
    "platform"
  ];

  const handleRestFile = () => {
    setFile(null);
    if(inpRef.current){
      inpRef.current.value = null;
    }
    setIsSheetSelected(false);
    setSelectedSheet(null);
    setSheetList([]);
    setExcelData([]);
    setColumns([]);
    setMapping({});
    setProcessing(false);
    setValidating(false);
    setErrors([]);
    setImporting(false);
    setResult(null);
    setSelectedCoach();
    setCoachSearch('');
    setDepartment('');
  }

  const handleUpload = () => {
      const reader = new FileReader();
  
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
  
        setSheetList(workbook.SheetNames);
      };
  
      if (file) {
        reader.readAsBinaryString(file);
        setOpenMapPopup(true);
      }
    }
  const handleMappingChange = (field, value) => {
    setMapping((prev) => ({
      ...prev,
      [field]: value && value.value ? value.value : "",
    }));
  };

  const handleSheet = () => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      // Assuming data is in the first sheet
      const sheetName = selectedSheet;
      const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

      if(worksheet.length == 0){
        alert('No data in selected file');
        return ;
      }

      const tmp_columns = worksheet[0]; // Get header row (first row)
      const data = worksheet.slice(1); // Get data rows (excluding header)

      setExcelData(data);

      setColumns(tmp_columns);

      // Initialize column mapping
      const initialMapping = {};
      all_fields.forEach((key) => {
        initialMapping[key] = tmp_columns.includes(key) ? key : '';
      });

      setMapping(initialMapping);
    };

    if (file) {
      reader.readAsBinaryString(file);
      setOpenMapPopup(true);
    }
  }


  const handleSubmitMappedFile = async () => {
    if(!isSheetSelected){
      if(selectedSheet == null){
        Swal.fire({
          title: "Please select sheet",
          icon: "error",
          confirmButtonText: "OK",
        })
        return ;
      }
      setIsSheetSelected(true);
      handleSheet();
      return ;
    }
    if(!mapping['firstName'] || mapping['firstName'] == "" ){
      Swal.fire({
        title: "Please select firstName Column",
        icon: "error",
        confirmButtonText: "OK",
      })
      return ;
    }
    if(!mapping['lastName'] || mapping['lastName'] == "" ){
      Swal.fire({
        title: "Please select lastName Column",
        icon: "error",
        confirmButtonText: "OK",
      })
      return ;
    }
    if(!mapping['email'] || mapping['email'] == "" ){
      Swal.fire({
        title: "Please select email Column",
        icon: "error",
        confirmButtonText: "OK",
      })
      return ;
    }
    console.log(mapping);
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "You won't be able to revert this!",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#3085d6",
    //   cancelButtonColor: "#d33",
    //   confirmButtonText: "Yes, delete it!"
    // })
    
    setProcessing(true);
    let mappedData = [];

    console.log(excelData, 'excelData');
    

    // Iterate over each row in the Excel data
    excelData.forEach((row) => {
      const mappedRow = {};

      // Iterate over each field in all_fields array
      all_fields.forEach((field) => {
        // Check if a valid mapping exists for this field
        const mappedColumn = mapping[field];

        // Find the index of the mapped column in the columns array
        const columnIndex = columns.indexOf(mappedColumn);

        // If the columnIndex is valid (exists in the row), map the value
        if (columnIndex > -1) {
          mappedRow[field] = row[columnIndex];  // Assign the corresponding value
        } else {
          mappedRow[field] = '';  // If not found, set it as empty or handle it differently
        }
      });

      // Add the mapped row to the mappedData array
      mappedData.push(mappedRow);
    });

    mappedData = mappedData.map(d => {
      if(d.gender == ""){
        delete d.gender;
      }
      return {
        ...d,
        organization: user.organization,
        type: userType,
        ...(d.gender ? {gender : d.gender.toUpperCase()} : {}),
        ...(selectedCoach && userType == "JOB_SEEKER" && selectedCoach._id ? { invitedBy: selectedCoach._id } : {}) 
      }
    })

    setExcelData(mappedData);
    console.log(mappedData, 'mappedData');
    setFile(null);
    setOpenMapPopup(false);
    setProcessing(false);

    validateData(mappedData);
  }

  const validateData = (data) => {
    setOpenFinalStep(true);
    setValidating(true);

    const errors = [];

    data.forEach((row, index) => {
      const rowErrors = [];

      // Helper to check valid string
      const isValidString = (value) =>
        typeof value === "string" && value.trim().length > 0;

      if (!isValidString(row.firstName)) {
        rowErrors.push("firstName required or invalid");
      }

      if (!isValidString(row.lastName)) {
        rowErrors.push("lastName required or invalid");
      }

      if (!isValidString(row.email)) {
        rowErrors.push("email required or invalid");
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(row.email)) {
          rowErrors.push("invalid email format");
        }
      }

      if(row.birthDate){
        try{
          const date = new Date(row.birthDate);
          if (isNaN(date.getTime())) {
            rowErrors.push("invalid birthDate format");
          }
        }catch(ex){
          rowErrors.push("invalid birthDate format");
        }
      }

      let list = ["MALE", "FEMALE", "OTHER"];
      if(row.gender && !list.includes(row.gender)){
        rowErrors.push("Gender must be MALE, FEMALE OR OTHER");
      }

      if (rowErrors.length > 0) {
        errors.push(`row ${index + 1}: ${rowErrors.join(", ")}`);
      }
    });

    setErrors(errors);

    setTimeout(()=>{
      setValidating(false);
    }, 2000)
  }

  const handleImport = async () => {
    setImporting(true);
    try{
      let res = await AddBulkUser(excelData);
      console.log(res.data)
      setResult(res.data);
      setSnackBarOpen(true);
      setSnackBarVariant("success");
      setSnackBarText("Import Successfully");
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      setSnackBarOpen(true);
      setSnackBarVariant("error");
      setSnackBarText(error);
    }finally{
      setImporting(false);
    }
  }
  
  // Jobseeker purchase history
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);


  return (
    <Card className="shadow-sm table__wrapper">
      <Card.Body>
        <Grid container direction="columnm" className="px-5">
          <Grid container direction="row" justify="space-between">
            <Grid item>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <SearchIcon />
                </div>
                <InputBase
                  placeholder="Search client by name, email and phone"
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  inputProps={{ "aria-label": "search" }}
                  onChange={searchText}
                />
              </div>
            </Grid>
            <Grid item>
              <FormControl style={{
                width: 130,
                marginTop: -5
              }}>
                <InputLabel id="demo-simple-select-label1">
                  Select Category
                </InputLabel>
                <Select
                  label="filter"
                  labelId="demo-simple-select-label1"
                  id="demo-simple-select"
                  value={filter}
                  onChange={onSelectCategory}
                >
                  <MenuItem value="All" selected>All</MenuItem>
                  <MenuItem value="BLOCKED">Blocked Users</MenuItem>
                  <MenuItem value="COACHES">Coaches</MenuItem>
                  <MenuItem value="JOB_SEEKERS">Job Seekers</MenuItem>

                </Select>
              </FormControl>

            </Grid>

            <Grid item>
              <div>
                <div>
                  <FormControl style={{
                    marginTop: -5
                  }}>
                    <InputLabel id="demo-simple-select-label">
                      Select Sort
                    </InputLabel>
                    <Select
                      label="filter"
                      // className="form-control border-0 form-control-solid py-5 px-6 my-3"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={sort}
                      onChange={(evt) => {
                        setSort(evt.target.value)
                        fetchUsers(page, rowsPerPage, search, evt.target.value, filter)
                      }}
                    >
                      <MenuItem value={1}>Ascending Order</MenuItem>
                      <MenuItem value={-1}>Descending Order</MenuItem>
                    </Select>

                  </FormControl>

                </div>
              </div>
            </Grid>
            {user.organization && <Grid item>
              <Button
                color="primary"
                className={classes.button}
                startIcon={<GroupAddOutlinedIcon style={{ fontSize: 25 }} />}
                onClick={handleDialogOpen}
              >
                <Typography className="px-3" variant="h6">
                  Add New Client
                </Typography>
              </Button>
            </Grid>}
          </Grid>
          <Grid item>
            <Snackbar
              open={snackBarOpen}
              autoHideDuration={5000}
              onClose={handleSnackBarClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Alert
                onClose={handleSnackBarClose}
                style={{ fontSize: "16px", backgroundColor: snackBarVariant === "error" ? "red" : "" }}
                severity={snackBarVariant}
              >
                {snackBarText}
              </Alert>
            </Snackbar>
          </Grid>
          <Grid item>
            <Dialog
              open={DialogState}
              onClose={handleDialogClose}
              aria-labelledby="form-dialog-title"
              maxWidth="sm"
              fullWidth="100%"
            >
              <DialogTitle id="form-dialog-title">
                <Typography variant="h6">ADD NEW CLIENT</Typography>
              </DialogTitle>
              <DialogContent>
                {/* <Select
                  label="type"
                  className="form-control border-0 form-control-solid py-5 px-6 my-3"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={userType}
                  onChange={hanldeUserType}
                >
                  <MenuItem value={"COACH"}>Coach</MenuItem>
                  <MenuItem value={"JOB_SEEKER"}>Job Seeker</MenuItem>
                </Select> */}

                <FormControl>
                  {/* <FormLabel id="demo-row-radio-buttons-group-label">
                    <Typography variant="h6">Gender
                    </Typography></FormLabel> */}
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onClick={hanldeUserType}
                    value={userType}
                  >
                    {/* <FormControlLabel value="ADMIN" control={<Radio />} label="Admin" /> */}
                    <FormControlLabel value="COACH" control={<Radio />} label="Career Coach" />
                    <FormControlLabel value="JOB_SEEKER" control={<Radio />} label="Client" />
                  </RadioGroup>
                </FormControl>

                {userType === "JOB_SEEKER" && <Grid item className="py-2 ">
                  {/* <div className={classes.search}>
                    <div className={classes.searchIcon}>
                      <SearchIcon />
                    </div> */}
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={coaches}
                    getOptionLabel={(option) => `${option.firstName.toString()} ${option.lastName.toString()}`}
                    onChange={(evt, newV) => setSelectedCoach(newV)}
                    sx={{ width: 300 }}
                    inputValue={coachSearch}
                    onInputChange={(event, newInputValue) => onChangesCoachesSearch(newInputValue)}
                    renderInput={(params) => <TextField {...params} label="Assigned Coach" />}
                  />
                  {/* </div> */}
                </Grid>}

                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  autoFocus
                  margin="dense"
                  placeholder="First Name"
                  type="text"
                  onChange={handleFirstName}
                  required
                />
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  margin="dense"
                  id="lname"
                  placeholder="Last Name"
                  type="text"
                  onChange={handleLastName}
                  required
                />
                <input
                  className="form-control form-control-solid h-auto py-5 px-6 my-3"
                  margin="dense"
                  id="email"
                  placeholder="Email Address"
                  type="email"
                  onChange={handleEmail}
                  required
                />

                {userType === "COACH" && (
                  <input
                    className="form-control form-control-solid h-auto py-5 px-6 my-3"
                    margin="dense"
                    placeholder="Department"
                    type="text"
                    value={department}
                    onChange={(evt) => setDepartment(evt.target.value)}
                  />
                )}

                { (userType == "JOB_SEEKER") && <>
                  <h1 style={{ textAlign: "center", marginTop: "5px", marginBottom: "5px" }}>OR</h1>
                  <Typography variant="body1" align="center">
                    Upload Excel File
                  </Typography>
                  <input
                    accept=".xlsx"
                    style={{ display: 'none' }}
                    id="upload-file"
                    type="file"
                    onChange={handleFileChange}
                    ref={inpRef}
                  />
                  <label style={{ display: "block" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                        style={{ width: file ? "78%" : "100%" }}
                        onClick={() => inpRef.current.click()}
                      >
                        { file ? "Change" : "Choose" } Excel File
                      </Button>
                      { file && <Button
                        variant="outlined"
                        color="error"
                        component="span"
                        // startIcon={<CloudUploadIcon />}
                        style={{ width: "20%",
                          color: "red",
                          borderColor: "red", }}
                        onClick={()=>{
                          inpRef.current.value = null
                          setFile(null)
                        }}
                      >
                        Remove
                      </Button> }
                    </div>
                  </label>
                </> }
              </DialogContent>
              <DialogActions>
                <Grid
                  className="px-5 mb-4"
                  container
                  direction="row"
                  justify="space-between"
                >
                  <Grid item>
                    <Button
                      size="large"
                      onClick={handleDialogClose}
                      variant={"contained"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>

                    { file ? <Button
                      size="large"
                      onClick={handleUpload}
                      color="secondary"
                      variant={"contained"}
                      className="px-10"
                    >
                      <Typography>Proccess { file.name }</Typography>
                    </Button> :
                    <Button
                    size="large"
                    onClick={handleAddClient}
                    color="secondary"
                    variant={"contained"}
                    className="px-10"
                    disabled={
                      firstName.length && lastName.length && email.length
                        ? false
                        : true
                    }
                  >
                    {addClientLoader ? (
                      <CircularProgress
                        size="20px"
                        style={{ color: "#ffffff" }}
                      />
                    ) : (
                      <Typography>Add</Typography>
                    )}
                  </Button> }
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
            <Dialog open={openMapPopup} onClose={()=>{
              // setFile(null);
              // setOpenMapPopup(false);
              setFile(null);
              setOpenMapPopup(false);
              setSelectedSheet(null);
              setIsSheetSelected(false);
              setSheetList([]);
              setExcelData([]);
              setColumns([]);
              setMapping({});
              inpRef.current.value = null
              handleRestFile();
            }} fullWidth maxWidth="md">
            <DialogTitle>Map Excel Columns</DialogTitle>
            <DialogContent>
              {!isSheetSelected && (
                <Grid container spacing={3} style={{minHeight: '50vh'}}>
                  <Grid item xs={12} sm={4}>
                      <label>Select Sheet</label>
                      <RSelect
                        placeholder={'Select Sheet'}
                        // value={}
                        value={selectedSheet ? {value: selectedSheet, label: selectedSheet}:null}
                        onChange={(value)=>{
                          if(!value){
                            setIsSheetSelected(false)
                          }else{
                            console.log(value);
                            setSelectedSheet(value.value);
                          }
                        }}
                        options={sheetList.map((col) => ({
                          value: col,
                          label: col
                        }))}
                        isClearable
                      />
                    </Grid>
                </Grid>
              )}
              {excelData.length > 0 && isSheetSelected && (
                  <Grid container spacing={3} style={{minHeight: '70vh'}}>
                    { userType == "JOB_SEEKER" && <>
                      <Grid item xs={12} sm={4}>
                        <label>Career Coach</label>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={coaches}
                          getOptionLabel={(option) => `${option.firstName.toString()} ${option.lastName.toString()}`}
                          onChange={(evt, newV) => setSelectedCoach(newV)}
                          sx={{ width: 300 }}
                          inputValue={coachSearch}
                          onInputChange={(event, newInputValue) => onChangesCoachesSearch(newInputValue)}
                          renderInput={(params) => <TextField {...params} label="Assigned Coach" />}
                        />
                      </Grid>
                    </> }
                    {all_fields.map((fieldKey, index) => (
                    <Grid item xs={12} sm={4} key={index}>
                        <label>{fieldKey} {['firstName', 'lastName', 'email'].includes(fieldKey) ? '(Required)':"(Optional)"}</label>
                        <RSelect
                          placeholder={fieldKey}
                          // value={}
                          value={mapping[fieldKey] ? { value: mapping[fieldKey], label: mapping[fieldKey] } : null}
                          onChange={(selectedOption) => handleMappingChange(fieldKey, selectedOption)}
                          options={columns.map((col) => ({
                            value: col,
                            label: col
                          }))}
                          isClearable
                        />
                      </Grid>
                    ))}
                    
                  </Grid>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={()=>{
                setOpenMapPopup(false);
                setFile(null);
                setSelectedSheet(null);
                setIsSheetSelected(false);
                setSheetList([]);
                setExcelData([]);
                setColumns([]);
                setMapping({});
                inpRef.current.value = null
                handleRestFile();
              }} color="primary">
                Cancel
              </Button>
              <Button disabled={processing} onClick={handleSubmitMappedFile} color="primary">
                {processing ? <CircularProgress
                        size="20px"
                        style={{ color: "#bb2124" }}
                      /> : !isSheetSelected ? 'Next' : 'Submit'}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={openFinalStep} disableBackdropClick onClose={()=>{
            setFile(null);
            setOpenMapPopup(false);
            setSelectedSheet(null);
            setOpenFinalStep(false);
            setValidating(false);
            inpRef.current.value = null;
            setResult(null);
            setFile(null);
            setSelectedSheet(null);
            setIsSheetSelected(false);
            setSheetList([]);
            setExcelData([]);
            setColumns([]);
            setMapping({});
            inpRef.current.value = null
            handleRestFile();
          }} fullWidth maxWidth="md">
          <DialogTitle>Final Step</DialogTitle>
          <DialogContent>
            { validating && result == null ? <>
                <div style={{textAlign: "center"}}>
                  <CircularProgress
                    size="20px"
                    style={{ color: "#bb2124" }}
                  />
                  <p>Validating your file Please wait</p>
                </div>
              </>: <>
               { errors.length > 0 ? <>
                <p>Please fix following error and import your file again</p>
                <ul style={{color: "red"}}>
                  { errors.map((err, i) => {
                    return <li key={i}>{err}</li>
                  }) }
                </ul>
               </> : <>
                  <p>Your file is validated successfully and ready for import.</p>
                  {/* {importing && <p>Your import process has been started It take some time you can close this window and you will be notifed onces it </p>} */}
               </> }     
              </>
            }
            {result && <>
              <p>Your file has been uploaded successfully.</p>
              <p>Imported {result.createdCount} users and {result.failedCount} failed.</p>
              { result.failedCount > 0 && <>
                <p>Erros:</p>
                <ul style={{color: "red"}}>
                  { result.errors.map((err, i) => {
                    return <li key={i}>{err}</li>
                  })}
                </ul>
              </> }

            </>}
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
              setFile(null);
              setOpenMapPopup(false);
              setSelectedSheet(null);
              setOpenFinalStep(false);
              setValidating(false);
              inpRef.current.value = null;
              setResult(null);
              handleRestFile();
            }} color="primary">
              {result ? 'Done':'Cancel'}
            </Button>
            { !result && errors.length == 0 && !validating && <Button disabled={importing} onClick={handleImport} color="primary">
              {importing ? <CircularProgress
                      size="20px"
                      style={{ color: "#bb2124" }}
                    /> : "Import"}
            </Button> }
            
          </DialogActions>
        </Dialog>
          </Grid>
        </Grid>

        <TableContainer className="mt-10">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                {headers.map((item, index) => (
                  <TableCell
                    key={index}
                    align="left"
                    classes={{ root: classes.tableHeadCell }}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <StyledTableRow key={index}>
                  <TableCell
                    classes={{
                      root: classes.tableRowCell,
                    }}
                    component="th"
                    scope="row"
                    align="left"
                    onClick={() => openUserDetails(row)}
                  >
                    {row.name}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.email}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.department || '—'}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.phone}
                  </TableCell>
                  {/* <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.stage}
                  </TableCell> */}
                  
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.paymentMessage}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {row.status}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    <Tooltip title={row.type == "Coach" ? "Click to change type to Jobseeker" : "Click to change type to Coach"} arrow>
                      <Button disabled={row.id == changeTypeUserId} variant="outlined" onClick={()=>{handleChangeType(row.id, row.type == "Coach" ? "JOB_SEEKER" : "COACH")}}>{changeTypeUserId == row.id ? <CircularProgress size="17px" className="mx-7 " /> : row.type}</Button>
                    </Tooltip>
                    {/* {row.type} */}
                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}

                  > {row.type === 'Admin' ? '--' :
                    row.type === 'Coach' ?
                      <Button
                        variant="outlined"
                        onClick={() => openSeeClientPopup(row.id)}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#28d604",
                          borderColor: "#28d604",
                          // width: 'max-content'
                        }}
                      >
                        <Typography>See Client</Typography>
                      </Button>
                      :
                      <Button
                        variant="outlined"
                        onClick={() => openAssignCoach(row)}
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#28d604",
                          borderColor: "#28d604",
                          // width: 'max-content'
                        }}
                      >
                        {assigningCoach ? (
                          <CircularProgress size="17px" className="mx-7 " />
                        ) : (
                          <Typography>{row.invitedBy ? "See Coach" : 'Assign'}</Typography>
                        )}
                      </Button>
                      // <SeeCoach selectedUser={row.invitedBy} />
                      // <Button
                      //   variant="outlined"
                      //   onClick={() => openSeeCoach(row.invitedBy)}
                      //   style={{
                      //     backgroundColor: "#ffffff",
                      //     color: "#28d604",
                      //     borderColor: "#28d604",
                      //     // width: '100px'
                      //   }}
                      // >
                      //   <Typography>See Coach</Typography>
                      // </Button>
                    }

                  </TableCell>
                  <TableCell
                    align="left"
                    classes={{ root: classes.tableRowCell }}
                  >
                    {/* <Dropdown as={ButtonGroup}>
                      <Dropdown.Toggle id="dropdown-basic" className="border">
                        {" actions "}
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          lineHeight: 0,
                          left: -100,
                          top: 40,
                        }}
                      >
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Block
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          className="p-6"
                          style={{ fontSize: "14px" }}
                        >
                          Unblock
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                   */}
                    {row.paymentMessage.toUpperCase() == "PAID" || row.type == "Job Seeker" ? 
                      row.action ? (
                        <Button
                          variant="outlined"
                          onClick={() => {
                            handleUnBlock(row.id, row.name);
                          }}
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#28d604",
                            borderColor: "#28d604",
                          }}
                        >
                          {userId === row.id ? (
                            <CircularProgress size="17px" className="mx-7 " />
                          ) : (
                            <Typography>Unblock</Typography>
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant="outlined"
                          style={{
                            borderColor: "#fc7e7e",
                            color: "#fc7e7e",
                            backgroundColor: "#ffffff",
                          }}
                          onClick={() => {
                            handleBlock(row.id, row.name);
                          }}
                          className="pl-7 pr-8"
                        >
                          {userId === row.id ? (
                            <CircularProgress
                              size="18px"
                              style={{ color: "#fc7e7e" }}
                              className="mx-4 "
                            />
                          ) : (
                            <Typography>Block</Typography>
                          )}
                        </Button>
                      ) :
                      <Button
                          variant="outlined"
                          style={{
                            borderColor: "#fc7e7e",
                            color: "#fc7e7e",
                            backgroundColor: "#ffffff",
                          }}
                          onClick={() => {
                            handleCreateCheckoutSession(row.id, row);
                          }}
                          className="pl-7 pr-8"
                        >
                          {paymentUserId === row.id ? (
                            <CircularProgress
                              size="18px"
                              style={{ color: "#fc7e7e" }}
                              className="mx-4 "
                            />
                          ) : (
                            <Typography>Make Payment</Typography>
                          )}
                        </Button>
                    }
                    { row.type == "Job Seeker" && <Button
                      variant="outlined"
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#28d604",
                        borderColor: "#28d604",
                      }}
                      onClick={() => {
                        setSelectedJobSeeker(row.id);
                        // handleBlock(row.id, row.name);
                      }}
                      className="pl-7 pr-8"
                    >
                       <Typography>Purchase History</Typography>
                    </Button> }
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
            <TablePagination
              count={count}
              page={page}
              onChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>
        {assignCoach && <AssignCoach selectedJobSeeker={selectedJs} open={AssignCoach} onClose={closeAssignCoach} onAssigngingCoach={onAssigngingCoach} />}
        {seeJobSeeker && <SeeClients open={seeJobSeeker} onClose={closeSeeClientPopup} selectedUser={selectedUser} />}
        {seeUserModal && selectedJs && <ClientProfile user={selectedJs} onClose={closeUserDetails} open={seeUserModal} refresh={refresh} />}
        {selectedJobSeeker && <JobseekerPurchaseHistory id={selectedJobSeeker} setSelectedJobSeeker={setSelectedJobSeeker} />}  
      </Card.Body>
    </Card>
    // </Box>
  );
}
